'use client';

const getTextColor = (active, disabled) => {
  if (disabled) return "onLight.disabled.muted";
  return active ? "onLight.text.primary" : "onLight.text.secondary";
};
export {
  getTextColor
};
